import { useState } from 'react'
import { useQueryClient } from 'react-query'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useMutation } from 'hooks/useMutation'
import { useQuery } from 'hooks/useQuery'

import { createCompletionRoom, fetchRoom } from 'utils/queries'
import { Toast } from 'utils/toast'

import { Room } from 'types/chat'

export const useCompletionRoom = ({ completionId }: { completionId?: string }) => {
  const queryClient = useQueryClient()
  const { data: currentUser } = useCurrentUser()

  const queryKey = ['completionRoom', completionId]
  const [roomId, setRoomId] = useState<string | undefined>(
    queryClient.getQueryData<Room>(queryKey)?.id || undefined,
  )

  const roomQuery = useQuery<Room | null>(
    queryKey,
    () => (roomId ? fetchRoom({ roomId }) : Promise.resolve(null)),
    {
      enabled: !!roomId,
    },
  )

  const createRoom = useMutation<{ id: string }>(
    () =>
      completionId && currentUser
        ? createCompletionRoom({ completionId, user: currentUser })
        : Promise.reject(),
    {
      onSuccess: (data) => {
        setRoomId(data.id)
      },
      onError: () => {
        Toast.error('Unable to create completion chat room', 'Please try again')
      },
    },
  )

  return {
    ...roomQuery,

    // Mutations
    createRoom,
  }
}
